import React, { useEffect, useState } from 'react';
import { NotificationCard, SideSheet } from '@gerdau/hefesto-mais-web';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import {
  loadCustomerContracts,
  setHighlightNewContracts
} from '../../../store/ducks/contracts-and-constructions/actions';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { ESettingsRoutes } from '../../Settings';
import { GetFlag } from '../../../utils/featureFlag';

interface INotificationsProps {
  onCloseNotifications: () => void;
  notificationIsOpen: boolean;
}

const Notifications: React.FC<INotificationsProps> = ({
  onCloseNotifications,
  notificationIsOpen
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const contractAndConstructionsSelectedCustomerId = useSelector(
    (state: ApplicationState) =>
      state.contractsAndConstructions.contractsManager.selectedCustomerId
  );
  const newContractNotifications = useSelector(
    (state: ApplicationState) => state.notifications.newContractNotifications
  );
  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [closeSideLeaf, setCloseSideLeaf] = useState(false);
  const hubNotificationFlag = GetFlag('hub_notificacoes');

  const goToNotificationPanel = () => {
    onCloseNotifications();
    history.push(`${ERoutes.NOTIFICATIONS}/`);
  };

  const goToNotificationsSettings = () => {
    onCloseNotifications();
    dispatch(
      sendTagging({
        screenName,
        event: 'click',
        itemDescription: `${itemDescription}configuracoes`,
        itemName: 'button:configuracoes'
      })
    );
    history.push(`${ERoutes.SETTINGS}/${ESettingsRoutes.NOTIFICATIONS}`);
  };

  const goToConstructionsHome = (customerId: string) => {
    setCloseSideLeaf(true);
    history.push(`${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}`);

    if (customerId !== contractAndConstructionsSelectedCustomerId) {
      dispatch(loadCustomerContracts(customerId, customerViewType));
    }

    dispatch(setHighlightNewContracts(true));
  };

  const location = useLocation();

  const { screenName = '', itemDescription = '' } =
    getTaggingInformationScreen('notifications');

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        screenName,
        page: location.pathname
      })
    );
  }, []);

  return (
    <>
      {hubNotificationFlag ? (
        <SideSheet
          title={'Notificações'}
          isOpen={notificationIsOpen}
          onClose={onCloseNotifications}
          notification={{
            count: newContractNotifications?.length as number,
            onClickSeeAll: () => {
              goToNotificationPanel();
            },
            onClickSettings: () => {
              goToNotificationsSettings();
            }
          }}
        >
          {newContractNotifications?.map((notification, idx) => (
            <NotificationCard
              key={idx}
              title={notification.title}
              viewed={false}
              description={
                'Um novo contrato foi liberado pelo vendedor(a) e está disponível para cadastrar uma nova obra.'
              }
              important={true}
              onSeeDetailsClick={() => {
                onCloseNotifications();
                goToConstructionsHome(notification.customerId);
                dispatch(
                  sendTagging({
                    screenName,
                    event: 'click',
                    itemDescription: `${itemDescription}verDetalhes`,
                    itemName: 'button:verDetalhes'
                  })
                );
              }}
            ></NotificationCard>
          ))}
        </SideSheet>
      ) : (
        <SideSheet
          title={'Notificações'}
          isOpen={notificationIsOpen}
          onClose={onCloseNotifications}
          notification={{
            count: newContractNotifications?.length as number,
            onClickSettings: () => {
              goToNotificationsSettings();
            }
          }}
        >
          {newContractNotifications?.map((notification, idx) => (
            <NotificationCard
              key={idx}
              title={notification.title}
              viewed={false}
              description={
                'Um novo contrato foi liberado pelo vendedor(a) e está disponível para cadastrar uma nova obra.'
              }
              important={true}
              onSeeDetailsClick={() => {
                onCloseNotifications();
                goToConstructionsHome(notification.customerId);
                dispatch(
                  sendTagging({
                    screenName,
                    event: 'click',
                    itemDescription: `${itemDescription}verDetalhes`,
                    itemName: 'button:verDetalhes'
                  })
                );
              }}
            ></NotificationCard>
          ))}
        </SideSheet>
      )}
    </>
  );
};

export default Notifications;
